import KitFadeView from '@omni/kit/components/KitFadeView';
import React, { ReactElement } from 'react';

import PlayerButton, {
  PlayerButtonProps,
  PlayerButtonSizes,
} from './PlayerButton';

export interface PlayPauseControlProps {
  isVisible?: boolean;
  isPlaying: boolean;
  size?: PlayerButtonSizes;
  trapFocusDirections?: PlayerButtonProps['trapFocusDirections'];
  onPress: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
}

export default function PlayPauseControl({
  isVisible,
  isPlaying,
  size,
  trapFocusDirections,
  onPress,
  onFocus,
  onBlur,
}: PlayPauseControlProps): ReactElement {
  return (
    <KitFadeView show={isVisible} keepElementSize>
      <PlayerButton
        size={size}
        title={isPlaying ? 'Pause' : 'Play'}
        icon={isPlaying ? 'pause' : 'play'}
        onPress={onPress}
        onFocus={onFocus}
        onBlur={onBlur}
        trapFocusDirections={trapFocusDirections}
        hasTVPreferredFocus={true}
      />
    </KitFadeView>
  );
}
